(function () {
  'use strict';

  var container = document.getElementById('upgrade-form-container');
  if (!container) return;

  var lookupForm = document.getElementById('upgrade-lookup-form');
  var selectForm = document.getElementById('upgrade-select-form');
  var submitForm = document.getElementById('upgrade-submit-form');
  var itemsEl = document.getElementById('upgrade-items');
  var summaryEl = document.getElementById('upgrade-order-summary');
  var targetEl = document.getElementById('upgrade-target');
  var successEl = document.getElementById('upgrade-success');
  var errorEl = document.getElementById('upgrade-error');

  var lookupUrl = container.dataset.lookupUrl || '';
  var submitUrl = container.dataset.submitUrl || '';
  var siteLang = container.dataset.lang || '';
  var store = container.dataset.store || 'mayuri';

  var loadedAtEl = document.getElementById('upgrade-form-loaded-at');
  if (loadedAtEl) loadedAtEl.value = String(Date.now());
  var MIN_FILL_MS = 3000;

  // Le binding hCaptcha du form caché (requis pour que son submit natif passe)
  // ne se déclenche que sur interaction — data-shopify-captcha ne suffit pas :
  // on simule un focusin dès le chargement pour binder en avance.
  var fallbackFormEl = document.getElementById('shopify-upgrade-fallback');
  if (fallbackFormEl) fallbackFormEl.dispatchEvent(new Event('focusin', { bubbles: true }));

  // Attend que le hCaptcha Shopify soit bindé sur le form avant de soumettre :
  // un submit sur un form protégé non bindé est avalé (preventDefault) sans suite.
  function whenCaptchaBound(formEl, cb) {
    if (formEl.dataset.hcaptchaBound || formEl.dataset.recaptchaBound) { cb(); return; }
    formEl.dispatchEvent(new Event('focusin', { bubbles: true }));
    var waited = 0;
    var timer = setInterval(function () {
      waited += 200;
      if (formEl.dataset.hcaptchaBound || formEl.dataset.recaptchaBound || waited >= 5000) {
        clearInterval(timer);
        cb();
      }
    }, 200);
  }

  // Retour du filet Shopify (soumission native /contact) → écran de succès
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    [lookupForm, selectForm, submitForm].forEach(function (f) {
      f.classList.add('upgrade-form__step--hidden');
    });
    successEl.style.display = 'block';
  }

  // Le filtre `t` HTML-échappe les apostrophes (&#39;) : on décode toutes les
  // chaînes du JSON i18n, elles sont injectées via textContent côté JS.
  function decodeEntities(value) {
    if (typeof value === 'string') {
      var el = document.createElement('textarea');
      el.innerHTML = value;
      return el.value;
    }
    if (value && typeof value === 'object') {
      Object.keys(value).forEach(function (k) { value[k] = decodeEntities(value[k]); });
    }
    return value;
  }

  var i18n = {};
  try {
    i18n = decodeEntities(JSON.parse(document.getElementById('upgrade-form-i18n').textContent));
  } catch (e) {
    i18n = {};
  }

  // Éligibilité par lettre métal du SKU (nomenclature TYPE-DESIGN-PIERRE+METAL-TAILLE).
  // Miroir de scripts-locaux/lib/sku-nomenclature.js — pas d'import possible côté thème.
  var ELIGIBLE_LETTERS = { A: 1, B: 1, R: 1, J: 1, K: 1, L: 1 }; // argent, vermeils, or 9 carats
  var JEWELRY_TYPES = { BA: 1, JO: 1, BR: 1, CO: 1, BO: 1, CR: 1, PE: 1 };
  var METAL_LABELS = {
    A: 'Argent 925',
    B: 'Or Vermeil 18 carats',
    D: 'Or blanc 18 carats',
    E: 'Or jaune 18 carats',
    F: 'Or rose 18 carats',
    G: 'Or blanc 14 carats',
    J: 'Or blanc 9 carats',
    K: 'Or jaune 9 carats',
    L: 'Or rose 9 carats',
    P: 'Platine',
    R: 'Or Vermeil Rose 18 carats'
  };
  var SKU_RE = /^([A-Z]{2})-([A-Z0-9]+)-((?:[0-9]{2}|H[123]))([A-Z])(?:-|$)/;

  // { eligible: bool, metalLetter: string|null }
  // SKU absent ou hors nomenclature → fail-open : sélectionnable, tri manuel côté atelier.
  function eligibility(sku) {
    var m = SKU_RE.exec((sku || '').trim().toUpperCase());
    if (!m) return { eligible: true, metalLetter: null };
    if (!JEWELRY_TYPES[m[1]]) return { eligible: false, metalLetter: m[4] };
    return { eligible: !!ELIGIBLE_LETTERS[m[4]], metalLetter: m[4] };
  }

  // Données de la commande retrouvée (renseignées après lookup réussi)
  var order = null;
  var selectedIndex = -1;

  // --- Étape 1 : lookup ---
  lookupForm.addEventListener('submit', function (e) {
    e.preventDefault();
    hideMessages();

    if (!lookupForm.checkValidity()) {
      lookupForm.reportValidity();
      return;
    }
    if (!lookupUrl) {
      showError(i18n.error_generic);
      return;
    }

    var email = lookupForm.querySelector('[name="email"]').value.trim();
    var orderNumber = lookupForm.querySelector('[name="order_number"]').value.trim();

    setLoading(true);

    // Multipart FormData (pas de JSON) : requête CORS "simple", aucun preflight —
    // même pattern que les formulaires retour / réparation / sur-mesure en prod.
    var lookupFd = new FormData();
    lookupFd.append('email', email);
    lookupFd.append('order_number', orderNumber);
    lookupFd.append('store', store);

    fetch(lookupUrl, {
      method: 'POST',
      body: lookupFd
    })
      .then(function (res) {
        if (!res.ok) throw new Error('lookup_failed');
        return res.json();
      })
      .then(function (data) {
        setLoading(false);
        if (!data || data.found !== true || !Array.isArray(data.items) || data.items.length === 0) {
          showError(i18n.lookup_not_found);
          return;
        }
        order = {
          email: email,
          order_number: data.order_number || orderNumber,
          customer_name: data.customer_name || '',
          items: data.items
        };
        var hasEligible = renderItems(data.items);
        if (summaryEl && i18n.order_summary) {
          summaryEl.textContent = i18n.order_summary.replace('{order}', order.order_number);
        }
        if (!hasEligible) {
          showError(i18n.no_eligible_items);
        }
        goToStep(selectForm);
      })
      .catch(function () {
        setLoading(false);
        showError(i18n.error_generic);
      });
  });

  function renderItems(items) {
    itemsEl.innerHTML = '';
    selectedIndex = -1;
    var hasEligible = false;

    items.forEach(function (item, idx) {
      var elig = eligibility(item.sku);

      var wrap = document.createElement('div');
      wrap.className = 'upgrade-form__item' + (elig.eligible ? '' : ' is-ineligible');

      var head = document.createElement('label');
      head.className = 'upgrade-form__item-head';

      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'upgrade_item';
      radio.dataset.index = idx;
      radio.className = 'upgrade-form__item-radio';
      if (!elig.eligible) radio.disabled = true;

      head.appendChild(radio);

      if (item.image) {
        var img = document.createElement('img');
        img.className = 'upgrade-form__item-thumb';
        img.src = item.image;
        img.alt = item.title || '';
        head.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'upgrade-form__item-info';

      var title = document.createElement('span');
      title.className = 'upgrade-form__item-title';
      title.textContent = item.title || '';
      info.appendChild(title);

      var variantText = [];
      if (item.variant_title && item.variant_title !== 'Default Title') variantText.push(item.variant_title);
      if (item.quantity && item.quantity > 1) variantText.push('×' + item.quantity);
      if (variantText.length) {
        var variant = document.createElement('span');
        variant.className = 'upgrade-form__item-variant';
        variant.textContent = variantText.join(' · ');
        info.appendChild(variant);
      }

      head.appendChild(info);

      if (!elig.eligible) {
        var tag = document.createElement('span');
        tag.className = 'upgrade-form__item-tag';
        tag.textContent = i18n.not_eligible || '';
        head.appendChild(tag);
      } else {
        hasEligible = true;
        radio.addEventListener('change', function () {
          selectedIndex = idx;
          var all = itemsEl.querySelectorAll('.upgrade-form__item');
          for (var i = 0; i < all.length; i++) all[i].classList.remove('is-selected');
          wrap.classList.add('is-selected');
        });
      }

      wrap.appendChild(head);
      itemsEl.appendChild(wrap);
    });

    return hasEligible;
  }

  // --- Étape 2 : continuer vers l'étape 3 ---
  selectForm.addEventListener('submit', function (e) {
    e.preventDefault();
    hideMessages();

    if (selectedIndex < 0 || !order || !order.items[selectedIndex]) {
      showError(i18n.no_item_selected);
      return;
    }

    renderTarget(order.items[selectedIndex]);
    goToStep(submitForm);
  });

  function renderTarget(item) {
    targetEl.innerHTML = '';

    if (item.image) {
      var img = document.createElement('img');
      img.className = 'upgrade-form__item-thumb';
      img.src = item.image;
      img.alt = item.title || '';
      targetEl.appendChild(img);
    }

    var info = document.createElement('div');
    info.className = 'upgrade-form__item-info';

    var title = document.createElement('span');
    title.className = 'upgrade-form__item-title';
    title.textContent = item.title || '';
    info.appendChild(title);

    // variant_title d'abord (déjà dans la langue de la commande) ; la table
    // METAL_LABELS (FR) ne sert qu'en secours et pour le payload interne.
    var sub = [];
    var elig = eligibility(item.sku);
    var metalLabel = elig.metalLetter ? METAL_LABELS[elig.metalLetter] : '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      sub.push(item.variant_title);
    } else if (metalLabel && i18n.target_summary) {
      sub.push(i18n.target_summary.replace('{metal}', metalLabel));
    }
    if (sub.length) {
      var variant = document.createElement('span');
      variant.className = 'upgrade-form__item-variant';
      variant.textContent = sub.join(' · ');
      info.appendChild(variant);
    }

    targetEl.appendChild(info);
  }

  // --- Filet Shopify : soumission NATIVE du form contact caché ---
  // Un fetch direct sur /contact répond 400 « Missing CAPTCHA token » : le
  // hCaptcha injecté par Shopify n'intercepte que les vrais événements submit.
  // On soumet donc en navigation pleine page, uniquement quand n8n échoue ;
  // au retour, ?contact_posted=true réaffiche l'écran de succès.
  function submitShopifyFallback(item, goldColorLabel, otherModel, comment) {
    var sf = document.getElementById('shopify-upgrade-fallback');
    if (!sf) return false;

    var elig = eligibility(item.sku);
    var body = 'DEMANDE UPGRADE OR 18 CARATS\n\n';
    body += 'Client : ' + (order.customer_name || '') + '\n';
    body += 'Email : ' + order.email + '\n';
    body += 'Commande : ' + order.order_number + '\n';
    body += 'Bijou : ' + (item.title || '') + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '') + '\n';
    body += 'SKU : ' + (item.sku || 'N/A') + '\n';
    body += 'Metal actuel : ' + (elig.metalLetter ? (METAL_LABELS[elig.metalLetter] || elig.metalLetter) : 'N/A') + '\n';
    body += 'Couleur or 18 carats souhaitee : ' + goldColorLabel + '\n';
    body += 'Autre modele : ' + (otherModel || 'Non') + '\n';
    body += '\nCommentaire :\n' + (comment || '-') + '\n';

    sf.querySelector('#uf-email').value = order.email;
    sf.querySelector('#uf-body').value = body;

    whenCaptchaBound(sf, function () {
      if (sf.requestSubmit) { sf.requestSubmit(); } else { sf.submit(); }
    });
    return true;
  }

  // --- Étape 3 : soumission (dual : Shopify + n8n) ---
  submitForm.addEventListener('submit', function (e) {
    e.preventDefault();
    hideMessages();

    if (selectedIndex < 0 || !order || !order.items[selectedIndex]) {
      showError(i18n.no_item_selected);
      return;
    }

    var colorEl = submitForm.querySelector('[name="gold_color"]:checked');
    if (!colorEl) {
      showError(i18n.no_color_selected);
      return;
    }

    if (!submitForm.checkValidity()) {
      submitForm.reportValidity();
      return;
    }

    // Anti-spam : honeypot rempli OU soumission trop rapide → faux succès, rien n'est envoyé
    var honeypot = submitForm.querySelector('[name="website"]');
    var loadedAt = parseInt(loadedAtEl && loadedAtEl.value, 10) || 0;
    var elapsed = Date.now() - loadedAt;
    if ((honeypot && honeypot.value) || (loadedAt && elapsed < MIN_FILL_MS)) {
      showSuccess();
      return;
    }

    var item = order.items[selectedIndex];
    var elig = eligibility(item.sku);
    var goldColorLabel = (i18n.gold_colors && i18n.gold_colors[colorEl.value]) || colorEl.value;
    var otherModel = (submitForm.querySelector('[name="other_model"]').value || '').trim();
    var comment = (submitForm.querySelector('[name="comment"]').value || '').trim();
    var pageUrl = (submitForm.querySelector('[name="page_url"]') || {}).value || window.location.href;

    setLoading(true);

    if (!submitUrl) {
      // Pas de webhook configuré → le form Shopify porte l'envoi seul (navigation)
      if (!submitShopifyFallback(item, goldColorLabel, otherModel, comment)) {
        setLoading(false);
        showError(i18n.error_generic);
      }
      return;
    }

    // Multipart FormData : scalaires en champs, bijou en `item` (JSON string).
    var fd = new FormData();
    fd.append('email', order.email);
    fd.append('order_number', order.order_number);
    fd.append('customer_name', order.customer_name || '');
    fd.append('item', JSON.stringify({
      id: item.id || null,
      variant_id: item.variant_id || null,
      title: item.title || '',
      variant_title: item.variant_title || '',
      quantity: item.quantity || 1,
      sku: item.sku || '',
      image: item.image || '',
      current_metal: elig.metalLetter ? (METAL_LABELS[elig.metalLetter] || '') : ''
    }));
    fd.append('gold_color', colorEl.value);
    fd.append('gold_color_label', goldColorLabel);
    fd.append('other_model', otherModel);
    fd.append('comment', comment);
    fd.append('lang', siteLang);
    fd.append('page_url', pageUrl);
    fd.append('store', store);
    // origine d'acquisition (journal first-party du snippet myr-attribution), pour l'attribution des demandes
    var myr = typeof window.myrAttribution === 'function' ? window.myrAttribution() : '';
    if (myr) fd.append('myr_attribution', myr);

    fetch(submitUrl, {
      method: 'POST',
      body: fd
    })
      .then(function (res) {
        if (!res.ok) throw new Error('submit_failed');
        return res.json().catch(function () { return {}; });
      })
      .then(function () {
        showSuccess();
      })
      .catch(function () {
        // n8n en échec → filet Shopify en soumission native (la page navigue)
        if (!submitShopifyFallback(item, goldColorLabel, otherModel, comment)) {
          setLoading(false);
          showError(i18n.error_generic);
        }
      });
  });

  // --- Navigation ---
  document.getElementById('upgrade-back-1').addEventListener('click', function () {
    hideMessages();
    goToStep(lookupForm);
  });

  document.getElementById('upgrade-back-2').addEventListener('click', function () {
    hideMessages();
    goToStep(selectForm);
  });

  function goToStep(formEl) {
    [lookupForm, selectForm, submitForm].forEach(function (f) {
      f.classList.toggle('upgrade-form__step--hidden', f !== formEl);
    });
    scrollToTop();
  }

  function setLoading(on) {
    container.classList.toggle('is-loading', on);
  }

  function showSuccess() {
    setLoading(false);
    submitForm.style.display = 'none';
    successEl.style.display = 'block';
    scrollToTop();
  }

  function showError(msg) {
    var bannerContent = errorEl.querySelector('.banner__content, p, span') || errorEl.querySelector('.banner');
    if (bannerContent) bannerContent.textContent = msg || i18n.error_generic || '';
    errorEl.style.display = 'block';
    successEl.style.display = 'none';
  }

  function hideMessages() {
    errorEl.style.display = 'none';
    successEl.style.display = 'none';
  }

  function scrollToTop() {
    window.scrollTo({ top: container.offsetTop - 100, behavior: 'smooth' });
  }
})();
